export default __webpack_public_path__ + "static/media/dhl-ecommerce-logo.12c52f2b.svg";